import React from 'react';
import styles from './ContentSection.module.css';
import HomeBuySection from './HomeBuySection';
import { CountryConfig } from 'lib/region/getCountrySpecificConfig';
import { ProductData } from './types';

interface ContentSectionProps {
  product: ProductData;
  title: string;
  text: string;
  ctaText?: string;
  onCtaClick?: () => void;
  countrySpecificConfigData: CountryConfig;
}

const Container = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.container}>{children}</div>
);

// const Title = styled.h2`
//   font-size: 24px;
//   margin-bottom: 16px;

//   @media (min-width: 768px) {
//     font-size: 32px;
//   }
// `;

// const Text = styled.div`
//   font-size: 16px;
//   line-height: 1.6;
//   margin-bottom: 24px;
// `;

// const CtaButton = styled.button`
//   padding: 12px 24px;
//   background-color: #0070f3;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   font-size: 16px;
//   cursor: pointer;
//   align-self: flex-start;
//   transition: background-color 0.3s;

//   &:hover {
//     background-color: #0060df;
//   }
// `;

const ContentSection: React.FC<ContentSectionProps> = ({
  product,
  title,
  countrySpecificConfigData,
}) => {
  console.log('Product in ContentSection:', product);
  return (
    <Container>
      <HomeBuySection
        title={title}
        countrySpecificConfigData={countrySpecificConfigData}
        // defaultOfferDiscount={2000}
        defaultStrikedPrice={true}
      />
    </Container>
  );
};

export default ContentSection;
